import { addDocuments, addAnswers } from './tools'

const documents = {
    'ticket.price': [
        'Wat kost een treinkaartje van station %station_from% naar %station_to%?',
        'Wat kost het va %station_from% naar %station_to%?', 'ticket.price',
        'Kosten %station_from% naar %station_to%?',
        'Hoeveel geld moet ik betalen van %station_from% naar %station_to%?',
        'Betalen van %station_from% naar %station_to%?',
        'Prijs %station_from% naar %station_to%',
    ],
}

const answers = {
    'ticket.price': [
        'Kei veel geld van {{station_from}} naar {{station_to}}!',
        'Je moet wel iets betalen voor de reis van {{station_from}} naar {{station_to}}!',
    ],
}

export default function (manager) {
    addDocuments(manager, documents, 'nl')
    addAnswers(manager, answers, 'nl')

    const station1 = manager.addTrimEntity('station_from')
    station1.addBetweenCondition('nl', 'van', 'naar')
    station1.addAfterLastCondition('nl', 'van')

    const station2 = manager.addTrimEntity('station_to')
    station2.addBetweenCondition('nl', 'naar', 'van')
    station2.addAfterLastCondition('nl', 'naar')

    manager.slotManager.addSlot('ticket.price', 'station_from', true, { nl: 'Waar vandaan gaat de reis?' })
    manager.slotManager.addSlot('ticket.price', 'station_to', true, { nl: 'Waar gaat de reis naar toe?' })
}
